module.exports = __webpack_public_path__ + "img/NL367.a24e0361.png";